<template>
  <div>
    <a-form :form="form" id="form">
      <a-form-item label="Note">
        <a-textarea
          placeholder="Write the note here ... "
          :rows="4"
          v-decorator="['catatan', { initialValue: initialData.catatan }]"
        />
      </a-form-item>
      <template v-if="mode == 'Create'">
        <a-form-item
          :label="item.actor"
          v-for="(item, index) in listAppr"
          :key="index"
        >
          <template v-if="item.nama == '-'">
            <a-select
              v-decorator="[
                item.actor.replace(/\s/g, '').toLowerCase(),
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in approval"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </template>
          <a-input
            disabled
            v-else
            v-decorator="[
              item.actor.replace(/\s/g, '').toLowerCase(),
              {
                rules: [{ required: false }],
                initialValue: item.nama,
                key: item.tlc,
              },
            ]"
          ></a-input>
        </a-form-item>
      </template>
      <template v-else>
        <a-row
          class="group-flex"
          v-for="item in listAppr"
          :key="item.tlc"
        >
          <a-col span="6">
            <label>{{ item.actor }} Approval</label>
          </a-col>
          <a-col span="1">:</a-col>
          <a-col
            ><a-tag>{{ item.nama }}</a-tag></a-col
          >
        </a-row>
      </template>
    </a-form>
    <!-- <a-row
      class="group-flex"
      v-for="item in collectData.approval"
      :key="item.tlc"
    >
      <a-col span="6">
        <h4>{{ item.actor }} Approval</h4>
      </a-col>
      <a-col span="1">:</a-col>
      <a-col
        ><span>{{ item.name }}</span></a-col
      >
    </a-row> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

export default {
  props: ["mode","listAppr","collectData"],
  name: "Persetujuan",
  data() {
    return {
      form: this.$form.createForm(this),
    };
  },
  created() {
    // this.FETCH_GA();
    // this.FETCH_VPM();
  },
  computed: {
    ...mapGetters(["getAtasan", "getAuth", "getAllBOD", "getGA", "getVPM"]),
    initialData: function () {
      if (this.collectData.informasi === undefined || this.collectData.informasi.length <= 0) {
        return {
          catatan: "",
        };
      } else {
        return {
          catatan: this.collectData.informasi.catatan ? this.collectData.informasi.catatan : "",
        };
      }
    },
    // listApproval(){
    //   if (this.mode == 'Edit'){
    //     return this.approval
    //   }else{
    //     return this.informasi.approval
    //   }
    // }
  },
  mounted() {
    if (this.mode !== "Edit") {
      this.getComboApproval().then((res) => {
        this.approval = res.data.approval;
      });
    }
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        Event.$emit("poData", { note: values.catatan?values.catatan:"" });
      });
    },
    async getComboApproval() {
      return await axios({
        method: "get",
        url: this.$serviceUrl + "pp/approval_combo_v2",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
  },
};
</script>

<style lang="less">
.group-flex {
  display: flex;
  margin-top: @margin / 2;
}
</style>
